package com.binayshaw7777.myportfolio.components.widgets

import androidx.compose.runtime.Composable
import com.binayshaw7777.myportfolio.utils.Constants
import com.binayshaw7777.myportfolio.utils.Res
import com.binayshaw7777.myportfolio.widgets.CircularStrokeImage
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.navigation.Link
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.cssRem

@Composable
fun SocialMediaIcons() {
    Row(
        modifier = Modifier.padding()
            .display(DisplayStyle.Flex)
            .cursor(Cursor.None)
            .flexDirection(FlexDirection.Row)
    ) {
        Link(
            path = Constants.GITHUB_URL,
            modifier = Modifier.cursor(Cursor.None)
        ) {
            CircularStrokeImage(
                src = Res.GITHUB_ICON,
                modifier = Modifier.margin(all = 0.6.cssRem)
            )
        }
        Link(
            path = Constants.LINKEDIN_URL,
            modifier = Modifier.cursor(Cursor.None)
        ) {
            CircularStrokeImage(
                src = Res.LINKEDIN_ICON,
                modifier = Modifier.margin(all = 0.6.cssRem)
            )
        }
        Link(
            path = Constants.TWITTER_URL,
            modifier = Modifier.cursor(Cursor.None)
        ) {
            CircularStrokeImage(
                src = Res.X_ICON,
                modifier = Modifier.margin(all = 0.6.cssRem)
            )
        }
        Link(
            path = Constants.BEHANCE_URL,
            modifier = Modifier.cursor(Cursor.None)
        ) {
            CircularStrokeImage(
                src = Res.BEHANCE_ICON,
                modifier = Modifier.margin(all = 0.6.cssRem)
            )
        }
        Link(
            path = Constants.MEDIUM_URL,
            modifier = Modifier.cursor(Cursor.None)
        ) {
            CircularStrokeImage(
                src = Res.MEDIUM_ICON,
                modifier = Modifier.margin(all = 0.6.cssRem)
            )
        }
    }
}